import { api } from './api'
import { ShiftModel } from '../types'

export interface CreateShiftData {
  code: string
  name: string
  description?: string | null
  type: '5R' | '3R'
  isActive?: boolean
}

export interface UpdateShiftData {
  code?: string
  name?: string
  description?: string | null
  type?: '5R' | '3R'
  isActive?: boolean
}

export const shiftService = {
  async getAll(includeInactive = false): Promise<ShiftModel[]> {
    const params = includeInactive ? { includeInactive: 'true' } : {}
    const response = await api.get('/configuration/shifts', { params })
    return response.data.data || response.data
  },

  async getActive(): Promise<ShiftModel[]> {
    // Usar getAll y filtrar solo los activos
    const response = await api.get('/configuration/shifts')
    const data = response.data.data || response.data
    return Array.isArray(data) ? data.filter((s: ShiftModel) => s.isActive) : []
  },

  async getById(id: string): Promise<ShiftModel> {
    const response = await api.get(`/configuration/shifts/${id}`)
    return response.data.data || response.data
  },

  async create(data: CreateShiftData): Promise<ShiftModel> {
    const response = await api.post('/configuration/shifts', data)
    return response.data.data || response.data
  },

  async update(id: string, data: UpdateShiftData): Promise<ShiftModel> {
    const response = await api.put(`/configuration/shifts/${id}`, data)
    return response.data.data || response.data
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/configuration/shifts/${id}`)
  },
}
